import {
  CommunityExtra,
  LightLectureExtra,
  PageExtra,
} from 'modules/comments/components/comments-list/comments-list.types'

export const isCommunityExtra = (
  extra: CommunityExtra | PageExtra | LightLectureExtra,
): extra is CommunityExtra => extra != null && typeof extra === 'object' && 'community' in extra

export const isLightLectureExtra = (
  extra: CommunityExtra | PageExtra | LightLectureExtra,
): extra is LightLectureExtra =>
  extra != null && typeof extra === 'object' && 'lightLecture' in extra
